import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { statsApi, brandApi } from '../api/client';
import type { DashboardStats } from '@bosamie/shared';
import { StatCardSkeleton, EmptyState } from '../components/ui';

export function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = async () => {
    setLoading(true);
    try {
      const data = await statsApi.get();
      setStats(data);
    } catch {
      // ignore
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStats(); }, []);

  if (loading) return <StatCardSkeleton />;

  if (!stats) return <div>加载失败</div>;

  if (stats.brandCount === 0) {
    return (
      <EmptyState
        title="还没有品牌，开始创建吧"
        action={
          <button className="btn btn-primary" onClick={() => navigate('/brands')}>
            去创建
          </button>
        }
      />
    );
  }

  const cards = [
    { label: '品牌总数', value: stats.brandCount, cls: 'brand' },
    { label: '款式总数', value: stats.modelCount, cls: 'accent' },
    { label: '在售商品', value: stats.saleCount, cls: 'ok' },
    { label: '待上架 · 隐藏 · 空位', value: stats.pendingCount + stats.hiddenCount + stats.emptyCount, cls: 'gray' },
  ];

  return (
    <div>
      <div className="stat-grid">
        {cards.map((c) => (
          <div key={c.label} className="stat-card">
            <div className="label">{c.label}</div>
            <div className={`value ${c.cls}`}>{c.value}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-header">
          <div className="card-title">快捷操作</div>
        </div>
        <div className="quick-actions">
          <button className="btn btn-primary" onClick={() => navigate('/brands')}>+ 新建品牌</button>
          <button className="btn btn-ghost" onClick={() => navigate('/brands')}>+ 新建款式</button>
          <button className="btn btn-ghost" onClick={() => navigate('/banners')}>上传轮播</button>
        </div>
      </div>
    </div>
  );
}
